import React from "react";
import { connect } from "react-redux";
import {
  Spinner,
  SpinnerSize,
  TextField,
  Label,
  SelectionMode,
  FocusZone,
  DetailsList,
  DetailsRow,
  Dropdown,
  TagPicker,
  Checkbox,
  PrimaryButton
} from "office-ui-fabric-react";



import moment from "moment";
import _ from "lodash";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroller";
import config from "../config";
import LeadForm from "./common/LeadForm";
import StatusBar from "./common/StatusBar";
import { USER_TYPE, LEAD_STATUS } from "../constants/enums";
import {
  LEAD_CATEGORY_LIST,
  PATIENT_ASSIGNMENT_LIST,
} from "../constants/lists";
import { LEAD_COLUMNS } from "../constants/tableConfig";
import { PATIENT_ASSIGNMENT } from "../../constants/enums";
import AssignCategoryForm from "./common/AssignCategoryForm";
import CustomerAddEditForm from "./common/CustomerAddEditForm";
import StartEndDateFilter from "./common/StartEndDateFilter";

export class Lead extends React.Component {

  constructor(props) {
    super(props);
    this.forms = {};
    this.div = {};

    this.limit = 100;
    this.rowRefs = {};
    var zipCodes = (props.auth.user.zipCodes || "")
      .split(",")
      .map((e) => e.trim())
      .map((e) => ({ key: e, text: e }));
    this.state = {
      showCustomerDialog: false,
      isEditing: false,
      searchText: "",
      customers: [],
      staffs: [],
      newCustomer: {
        processResults: "LE",
        zipCode: (zipCodes[0] || {}).key,
        birthDate: new Date()
      },
      isLoading: false,
      hasMore: true,
      zipCodes: zipCodes,
      filterZipCodes: [],
      total: 0,
      filterYearStart: 0,
      filterYearEnd: 0,
      filterStaff: "all",
      filterReminder: false,
      dateRangeOptions: (() => {
        var result = [];
        /*for (var i = 1900; i <= new Date().getFullYear(); i++) {
          result.push({
            text: i.toString(),
            key: i,
          });
        }*/
        result.push({ text: "aaaa", key: "aaa" })
        return result;
      })(),
      patientAssign: _.get(props, "location.state.pa", ""),
      headerFilters: {},
      openHeaderFilters: true,
      callingToCustomer: null,
      callingToPhone: "",
      callStatus: "",
      insurancedoc: null,
      leadClasses: [{ key: "", text: "All" }, { key: "served", text: "Served" }, { key: "good", text: "Good" }, { key: "bad", text: "Bad" }],
      leadClass: "",
      showCatDialog: false
    };

    this.changeFilter = this.changeFilter.bind(this);
    this.handleGetColumnConfig = this.handleGetColumnConfig.bind(this);
    this.renderHeaderFilter = this.renderHeaderFilter.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.updateStateCallback = this.updateStateCallback.bind(this);
    this.refreshCustomerList = this.refreshCustomerList.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.fetch = this.fetch.bind(this);

  }

  componentDidMount() {
    axios.get(`${config.apiUrl}/zipcode/ofme`).then(({ data }) => {
      this.setState({
        zipCodes: data,
        newCustomer: {
          processResults: "LE",
          zipCode: (data[0] || {}).key,
          birthDate: new Date()
        },
      });
    });

    axios.get(`${config.apiUrl}/user/list`).then(({ data }) => {
      this.setState({
        staffs: data
          .filter((e) => e.accountType === "staff")
          .map((e) => ({ key: e._id, text: e.email })),
        closers: data
          .filter((e) => e.accountType === "closer")
          .map((e) => ({
            key: e._id,
            text: `${e.fname} ${e.lname} | ${e.email}`,
          })),
      });
    });

    axios
      .get(`${config.apiUrl}/user/me`)
      .then(({ data }) => {
        this.setState({
          userData: data,
        });
      })
      .catch((ex) => {
        console.error("[ERROR - /user/me]:", ex);
      });

    axios.get(`${config.apiUrl}/organization/list?orgtype=vendor`).then(({ data }) => {
      if (!_.isEmpty(data))
        this.setState({
          vendors: data
            .map((e) => ({ key: e._id, text: e.name }))
        });
    });

    axios
      .get(`${config.apiUrl}/twilio/token`)
      .then(({ data }) => {
        this.timerTwilio = setInterval(() => {
          try {
            Twilio && Twilio.Device && this.setUpTwilio(data);
          } catch (ex) {
            console.error(ex);
            alert(
              "Have an error when connect to Twilio, refresh the website and try again"
            );
          }
          clearInterval(this.timerTwilio);
        }, 1000);
      })
      .catch((ex) => {
        console.error("[ERROR - /twilio/token]:", ex);
      });

    //Fix issue about tabindx.
    this.FocusZoomKeyDown = FocusZone.prototype._onKeyDownCapture;
    FocusZone.prototype._onKeyDownCapture = function () { };
    this.fetch("", 0, () => {
      if (null != this.props.location) {
        var id = this.props.location.query.id;
        if (id) {
          axios.get(`${config.apiUrl}/customer/get/${id}`).then(({ data }) => {
            var f = this.state.customers.find((c) => c._id == data._id);
            if (!f) {
              var customers = [data].concat(this.state.customers);
              f = data;
              this.setState(
                {
                  customers: customers,
                },
                () => {
                  setTimeout(() => {
                    this.selectItem(f);
                  }, 500);
                }
              );
            } else {
              var customers = this.state.customers.filter(
                (e) => e._id != data._id
              );
              customers = [f].concat(customers);
              this.setState(
                {
                  customers: customers,
                },
                () => {
                  setTimeout(() => {
                    this.selectItem(f);
                  }, 500);
                }
              );
            }
          });
        }
      }
    });
  }

  componentWillUnmount() {
    FocusZone.prototype._onKeyDownCapture = this.FocusZoomKeyDown;
    Twilio.Device.instance.removeAllListeners();
    clearInterval(this.timerTwilio);
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      customers: [],
      hasMore: true,
    });
    if (newProps.searchBox !== this.props.searchBox) {
      this.fetch(newProps.searchBox, 0);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      _.get(this.props, "location.state.pa") !==
      _.get(prevProps, "location.state.pa")
    ) {
      this.setState(
        {
          patientAssign: _.get(this.props, "location.state.pa", ""),
        },
        () => {
          this.fetch(this.props.searchBox, 0);
        }
      );
    }
  }

  twilioReady() {
    this.updateCallStatus("Ready to call");
  }

  twilioConnect(connection) {
    this.callId = connection.parameters.CallSid;
    if ("phoneNumber" in connection.message) {
      if (this.state.callingToCustomer) {
        this.setState(({ callingToCustomer }) => ({
          callingToCustomer: {
            ...callingToCustomer,
            callingStatus: "open",
          },
        }));
      }
      this.updateCallStatus("In call");
    }
  }
  twilioError(error) {
    console.error(error);
    this.updateCallStatus("Error" + error.message);
    if (this.state.callingToCustomer) {
      this.setState(({ callingToCustomer }) => ({
        callingToCustomer: {
          ...callingToCustomer,
          callingStatus: "error",
        },
      }));
    }
    this.setState({
      callingToCustomer: null,
    });
  }
  twilioDisconnect() {
    clearInterval(this.timeoutCheckResponse);
    if (this.state.callingToCustomer) {
      this.setState(({ callingToCustomer }) => ({
        callingToCustomer: {
          ...callingToCustomer,
          callingStatus: "closed",
        },
      }));
    }
    if (this.callId && this.state.callingToCustomer) {
      setTimeout(() => {
        axios
          .get(`${config.apiUrl}/twilio/response/${this.callId}`)
          .then((v) => {
            this.callId = "";
            const data = v.data;
            if (
              !data ||
              [
                "failed",
                "canceled",
                "queued",
                "ringing",
                "initiated",
                "no-answer",
              ].includes(data.CallStatus)
            ) {
              this.setState(({ callingToCustomer }) => ({
                callingToCustomer: {
                  ...callingToCustomer,
                  processResults: "NA",
                },
              }));
              this.saveChange(this.state.callingToCustomer);
              this.updateCallStatus("No Answer");
              this.timeoutCheckResponse = setTimeout(() => {
                this.callId = "";
                this.setState(
                  {
                    callingToCustomer: null,
                  },
                  () => {
                    this.callButtonClick();
                  }
                );
              }, 1000);
              return;
            } else if (
              data &&
              ["completed", "in-progress"].includes(data.CallStatus)
            ) {
              this.setState(({ callingToCustomer }) => ({
                callingToCustomer: {
                  ...callingToCustomer,
                  callingStatus: "answer",
                },
              }));
              this.showProcess(this.state.callingToCustomer);
            }

            this.setState(
              {
                callingToCustomer: null,
              },
              () => {
                this.updateCallStatus("Ready to call");
              }
            );
          })
          .catch((ex) => {
            this.callId = "";
            console.error(ex);
            alert("Have an error when check response of dial");
          });
      }, 1000);
    } else if (this.callId && this.state.callingToPhone) {
      this.callId = "";
      this.setState(
        {
          callingToPhone: "",
        },
        () => {
          this.updateCallStatus("Ready to call");
        }
      );
    } else {
      this.callId = "";
      this.updateCallStatus("Ready to call");
      this.setState({
        callingToCustomer: null,
      });
    }
  }

  setUpTwilio(data) {
    if (Twilio.Device.instance) {
      this.updateCallStatus("Ready to call");
    } else {
      Twilio.Device.setup(data);
    }

    Twilio.Device.ready(() => this.twilioReady());
    Twilio.Device.error((error) => this.twilioError(error));
    Twilio.Device.connect((connection) => this.twilioConnect(connection));
    Twilio.Device.disconnect((connection) => this.twilioDisconnect(connection));
  }

  /* End a call */
  hangUp() {
    clearInterval(this.timeoutCheckResponse);
    if (this.callId) {
      // if (this.state.callingToCustomer) {
      //   this.setState(({ callingToCustomer }) => ({
      //     callingToCustomer: {
      //       ...callingToCustomer,
      //       callingStatus: "closed",
      //     },
      //   }));
      // }

      this.setState(
        {
          callingToCustomer: null,
          callingToPhone: "",
        },
        () => {
          Twilio.Device.disconnectAll();
          this.callId = "";
        }
      );
    }
  }

  voiceCall(customer, evt) {
    evt && evt.stopPropagation && evt.stopPropagation();
    clearInterval(this.timeoutCheckResponse);
    this.callId = "";
    customer.callingStatus = "calling";
    if (!this.rowRefs[customer._id]) {
      alert("Scroll down to new customer, which don't have status");
      return;
    }
    this.rowRefs[customer._id].scrollIntoView({
      behavior: "smooth",
      block: "center",
      inline: "nearest",
    });
    this.setState(
      {
        callingToCustomer: customer,
      },
      () => {
        this.updateCallStatus("Calling");
        let phone = customer.phone;
        const phoneParam = new URLSearchParams(window.location.search).get("p");
        if (phoneParam) {
          phone = phoneParam.trim();
        }
        const params = {
          phoneNumber: phone,
          callFrom: _.get(this.state, "userData.phonecall"),
        };
        Twilio.Device.connect(params);
      }
    );
  }

  callButtonClick() {
    clearInterval(this.timeoutCheckResponse);
    if (this.state.callStatus === "") return;
    if (this.callId) {
      this.hangUp();
      axios
        .post(`${config.apiUrl}/auth/traking`, {
          type: "hang-up",
        })
        .catch((ex) => {
          console.error("[ERROR - /auth/traking]:", ex);
        });
    } else {
      axios
        .post(config.apiUrl + "/auth/traking", {
          type: "call",
        })
        .catch((ex) => {
          console.error("[ERROR - /auth/traking]:", ex);
        });
      const phoneNumber = this.refs.phoneNumber.value || "";
      if (phoneNumber.trim().length < 7) {
        const customers = this.state.customers;
        const foundCust = customers.find((e) => !e.processResults && !!e.phone);
        if (foundCust) {
          this.voiceCall(foundCust);
        }
      } else {
        this.setState(
          {
            callingToPhone: phoneNumber,
          },
          () => {
            this.updateCallStatus("Calling");

            var params = {
              phoneNumber: phoneNumber,
              callFrom: _.get(this.state, "userData.phonecall"),
            };
            Twilio.Device.connect(params);
          }
        );
      }
    }
  }

  updateCallStatus(s) {
    this.setState({
      callStatus: s,
    });
  }

  _onFilterChanged(filterText, list) {
    if (null == this.state.zipCodes) {
      return [];
    }

    var check = {};
    (list || []).forEach((e) => (check[e.key] = true));

    var ftext = filterText.trim().toLowerCase();
    var result = [];
    for (let zipcode of this.state.zipCodes) {
      const tag = zipcode;
      if (tag.indexOf(ftext) === 0 && !check[tag]) {
        result.push(tag);
        if (result.length >= 20) break;
      }
    }
    result = result.map((e) => {
      return {
        key: e,
        name: e,
      };
    });

    return result;
  }

  fetch(text, skip, cb) {

    if (this.state.isLoading) {
      return;
    }

    this.setState({
      isLoading: true,
    });

    const isCloserPage =
      _.get(this.props, "location.state.isCloser") ||
      _.get(this.props, "auth.user.accountType") === USER_TYPE.CLOSER;
    const commonParams = {
      process: "LE",
      pa: this.state.patientAssign,
      zipCodes: this.state.filterZipCodes.map((e) => e.key),
      filterSearch:
        text == undefined || text == null
          ? this.props.searchBox.filter || ""
          : text.filter,
      q:
        text == undefined || text == null
          ? this.props.searchBox.text || ""
          : text.text,
      staffAssignedId:
        this.state.filterStaff == "all" ? "" : this.state.filterStaff,
      filterYearStart: this.state.filterYearStart,
      filterYearEnd: this.state.filterYearEnd,
      filterReminder: this.state.filterReminder,
      filterFirstName: this.state.headerFilters.firstName,
      filterLastName: this.state.headerFilters.lastName,
      filterAddress: this.state.headerFilters.address,
      filterCity: this.state.headerFilters.city,
      filterZipCode: this.state.headerFilters.zipCode,
      filterCreatedStart: this.state.headerFilters.createdStart,
      filterCreatedEnd: this.state.headerFilters.createdEnd,
      filterCloserAssignedStart: this.state.headerFilters.closerAssignStart,
      filterCloserAssignedEnd: this.state.headerFilters.closerAssignEnd,
      filterPhone: this.state.headerFilters.phone,
      filterStaff: this.state.headerFilters.staff,
      ...(isCloserPage
        ? {
          isCloserPage: true,
        }
        : {
          isLeadPage: true,
        }),
      leadClass: this.state.leadClass
    };

    axios
      .get(`${config.apiUrl}/customer/list`, {
        params: {
          ...commonParams,
          limit: this.limit,
          skip: skip != undefined ? skip : this.state.customers.length,
        },
      })
      .then(({ data }) => {
        const duplicatedCusts = _.intersectionBy(
          data,
          this.state.customers,
          "_id"
        );
        const newCustomers = data.filter(
          (e) => !duplicatedCusts.some((c) => c._id === e._id)
        );
        const customers =
          skip === 0 ? data : this.state.customers.concat(newCustomers);
        this.setState({
          customers,
          isLoading: false,
          hasMore: newCustomers.length >= this.limit,
        });
        cb && cb();
      })
      .catch((ex) => {
        this.setState({
          isLoading: false,
          hasMore: false,
        });
        cb && cb();
      });

    axios
      .get(`${config.apiUrl}/customer/count`, {
        params: commonParams,
      })
      .then(({ data }) => {
        this.setState({
          total: data.total,
        });
      })
      .catch((ex) => { });
  }

  saveChange(customer) {
    /*if ("WN" === customer.processResults) {
      this.deleteCustomer(customer);
    } else {
      customer.staffAssignedId = this.props.auth.user._id;
      customer.staffAssigned = this.props.auth.user;
      axios
        .post(`${config.apiUrl}/customer/update`, customer)
        .then(({ data }) => {
          this.setState({
            customers: this.state.customers.map((cust) => {
              if (cust._id === data._id) {
                return data;
              }
              return item;
            }),
          });
        })
        .catch((ex) => {
          console.error("[ERROR - /customer/update]:", ex);
          alert("Request updating customer failed!");
        });
    }*/
  }


  //   changeFilter(v) {
  //     this.setState(
  //       {
  //         filter: v.key,
  //         customers: [],
  //         hasMore: true,
  //       },
  //       () => this.fetch(this.props.searchBox, 0)
  //     );
  //     // setTimeout(() => {
  //     //   this.fetch(this.props.searchBox, 0);
  //     // }, 200);
  //   }

  changeFilterStaff(v) {
    this.setState(
      {
        filterStaff: v.key,
        customers: [],
        hasMore: true,
      },
      () => this.fetch(this.props.searchBox, 0)
    );
    // setTimeout(() => {
    //   this.fetch(this.props.searchBox, 0);
    // }, 200);
  }

  changeFilterYear(start, end) {
    this.setState(
      {
        filterYearStart: start,
        filterYearEnd: end,
        customers: [],
        hasMore: true,
      },
      () => {
        this.fetch(this.props.searchBox, 0);
      }
    );
  }

  changeFilterByZipCodes(items) {
    this.setState(
      {
        customers: [],
        hasMore: true,
        filterZipCodes: [].concat(items),
      },
      () => {
        this.fetch(this.props.searchBox, 0);
      }
    );
  }

  changeFilter(name, value) {
    this.setState(
      {
        [name]: value,
        customers: [],
        hasMore: true,
      },
      () => {
        this.fetch(this.props.searchBox, 0);
      }
    );
  }

  selectItem(e) {
    try {
      var selection = window.getSelection();
      if (selection.toString().length > 0) {
        return;
      }
    } catch (ex) { }

    if (this.selectedItem != e) {
      this.tmpSelectedItem &&
        this.resetBgDiv(this.div[this.tmpSelectedItem._id]);
      this.selectedItem && this.resetBgDiv(this.div[this.selectedItem._id]);
      this.selectedItem && this.forms[this.selectedItem._id].hide();
      this.forms[e._id].show();
      this.changeBgDiv(this.div[e._id]);
      this.scrollY = window.scrollY;
      this.selectedItem = e;
      this.tmpSelectedItem = null;
      window.history.replaceState("", "", "/lead?id=" + e._id);
    } else {
      this.selectedItem && this.resetBgDiv(this.div[this.selectedItem._id]);
      this.selectedItem && this.forms[this.selectedItem._id].hide();
      this.selectedItem = null;
      this.tmpSelectedItem = null;
      window.history.replaceState("", "", "/lead");
    }

    this.forceUpdate();
  }

  hiddenForm(e) {
    if (e == this.selectedItem) {
      this.selectedItem && this.forms[e._id].hide();
      // this.selectedItem && this.resetBgDiv(this.div[e._id])
      this.tmpSelectedItem = this.selectedItem;
      // this.scrollToItem(e);
      this.backToPossitionScroll();
      this.selectedItem = null;
      window.history.replaceState("", "", "/lead");
    }
  }

  backToPossitionScroll() {
    window.scrollTo(0, this.scrollY);
  }

  scrollToItem(e) {
    var div = this.div[e._id];
    div.scrollIntoView();
    window.scrollTo(0, window.scrollY - 100);
  }

  resetBgDiv(div) {
    div.style.background = "";
  }

  changeBgDiv(div) {
    div.style.background = "#f0f0f0";
  }

  save(data) {

    const conf = {
      headers: {
        'content-type': 'multipart/form-data'
      },

    }

    var form_data = new FormData();

    for (var key in data) {
      if (data[key] !== undefined && data[key] !== null)
        form_data.append(key, data[key]);
    }

    if (this.state.insurancedoc !== undefined && this.state.insurancedoc !== null)
      for (let insurancedoc of this.state.insurancedoc) {
        form_data.append("insurancedoc", insurancedoc);
      }

    if (data.patientAssignment === PATIENT_ASSIGNMENT.SEND_BACK) {
      this.sendBackToCU(data);
    } else {
      axios
        .post(`${config.apiUrl}/customer/update`, form_data, conf)
        .then(({ data }) => {
          let customers = this.state.customers;
          const i = customers.findIndex((e) => e._id == data._id);
          if (i >= 0) {
            if (data.status === LEAD_STATUS.DELETED) {
              customers = customers.filter((cust) => cust._id !== data._id);
            } else {
              customers[i] = data;
            }
          } else {
            customers.push(data);

            setTimeout(() => {
              this.selectItem(data);
            }, 500);
          }
          this.resetPageData(customers);

        })
        .catch((ex) => {
          console.error(ex);
          // alert('Error');
        });
    }
  }

  sendBackToCU(data) {
    axios
      .post(`${config.apiUrl}/customer/sendBackToCU`, {
        _id: data._id,
        comments: data.comments,
      })
      .then(() => {
        var customers = this.state.customers.filter((e) => e._id != data._id);
        this.rowSelected = null;
        this.setState({
          customers: customers,
          showCustomerDialog: false,
          newCustomer: {
            processResults: "LE",
            zipCode: (this.state.zipCodes[0] || {}).key
          },
        });
      })
      .catch((ex) => {
        console.error(ex);
        // alert('Error');
      });
  }

  deletePatient() {
    if (confirm("Do you want to delete this record?")) {
      axios
        .post(`${config.apiUrl}/customer/remove`, {
          _id: this.state.newCustomer._id,
        })
        .then(({ data }) => {
          var customers = this.state.customers.filter((e) => e._id != data._id);
          this.rowSelected = null;
          this.setState({
            customers: customers,
            showCustomerDialog: false,
            newCustomer: {
              processResults: "LE",
              zipCode: (this.state.zipCodes[0] || {}).key,
            },
          });
        })
        .catch((ex) => {
          alert("Error");
        });
    }
  }

  showDialog() {
    this.setState({
      showCustomerDialog: true,
      isEditing: false,
    });
  }

  editCustomer(data, evt) {
    evt && evt.stopPropagation && evt.stopPropagation();
    this.setState({
      showCustomerDialog: true,
      isEditing: true,
      newCustomer: {
        _id: data._id,
        firstName: data.firstName || "",
        lastName: data.lastName || "",
        middleName: data.middleName || "",
        address: data.address || "",
        birthDate: data.birthDate ? new Date(data.birthDate) : new Date(),
        city: data.city || "",
        emailAddress: data.emailAddress || "",
        phone: data.phone || "",
        state: data.state || "",
        zipCode: data.zipCode || "",
        patientAssignment: data.patientAssignment || "",
        closerRemind: data.closerRemind,
        status: data.status || "",
        leadCategory: data.leadCategory || "",
        comments: data.comments || "",
        assignedToCloserId: data.assignedToCloserId || "",
        assignedToVendorId: data.assignedToVendorId || "",
        leadClass: data.leadClass || ""
      },
    });
  }

  verifyLead(data, evt) {
    evt && evt.stopPropagation && evt.stopPropagation();
    if (confirm("Do you want to verify this lead?")) {
      axios
        .post(`${config.apiUrl}/customer/verify`, {
          _id: data._id,
        })
        .then(({ data }) => {
          var customers = this.state.customers.filter((e) => e._id != data._id);
          this.rowSelected = null;
          this.setState({
            customers: customers,
          });
        })
        .catch((ex) => {
          alert("Error");
          s;
        });
    }
  }

  closeDialog() {
    this.setState({
      showCustomerDialog: false,
      newCustomer: {
        processResults: "LE",
        zipCode: (this.state.zipCodes[0] || {}).key,
        birthDate: new Date()
      },
      insurancedoc: null
    });
  }
  valueChange(key, v) {
    this.setState((prevState) => ({
      newCustomer: { ...(prevState.newCustomer || {}), [key]: v },
    }));
  }


  handleScanClick() {
    this.insurancedoc.click();
  };

  onFileChange(event) {
    let target = event.target;

    this.setState((prevState) => ({
      insurancedoc: target.files
    }));
  };

  print(e, evt) {
    evt && evt.stopPropagation && evt.stopPropagation();
    var url =
      config.apiUrl +
      "/customer/pdf/" +
      e._id +
      "?token=" +
      this.props.auth.user.token;
    var win = window.open(url);
    win.focus();
  }


  updateStateCallback(e, cb = () => { }) {

    this.setState(e, cb);
  }

  refreshCustomerList(data) {

    let newcustomers = this.state.customers.map((item) => {
      if (item._id === data._id) {
        return data;
      }
      return item;
    }).filter((item) => item.processResults === "LE");

    if (newcustomers.filter((item) => item._id === data._id).length == 0)
      newcustomers.unshift(data);


    console.log(newcustomers)
    this.setState({
      customers: newcustomers,
      total: newcustomers.length
    });

  }

  showProcess(e, evt, action) {
    evt && evt.stopPropagation && evt.stopPropagation();
    this.rowSelected = e;
    this.selected = e.processResults;

    this.setState({
      showCatDialog: true
    });


  }

  handleGetColumnConfig(isCloserPage, isVendor) {

    const { auth } = this.props;
    //let columns = LEAD_COLUMNS;

    let columns = LEAD_COLUMNS.filter((col) =>
      col.key === "assignedToCloserAt" && _.get(auth, "user.accountType") === "closer"
      || col.key !== "assignedToCloserAt")

    return columns.map((col) => {
      if (col.key === "process") {
        col.onRender = (item) => {
          return (
            item.key !== "filterRow" && (
              <div>
                {isCloserPage && (<button
                  className="tbl-btn"
                  onClick={(e) => this.verifyLead(item, e)}
                >
                  <i className="ms-Icon ms-Icon--Touch" aria-hidden="true"></i>
                </button>)}


                {isCloserPage && (<button
                  className="tbl-btn"
                  onClick={(e) => this.showProcess(item, e, _.get(this.props, "location.pathname"))}
                ><i className="ms-Icon ms-Icon--AddGroup" aria-hidden="true"></i>
                </button>)}

                {!isVendor && (<button
                  className="tbl-btn"
                  onClick={(e) => this.editCustomer(item, e)}
                >
                  <i className="ms-Icon ms-Icon--Edit" aria-hidden="true"></i>
                </button>)}
                <button
                  className="tbl-btn"
                  onClick={(e) => this.print(item, e)}
                >
                  <i className="ms-Icon ms-Icon--Print" aria-hidden="true"></i>
                </button>

                {!isVendor && (<button
                  className="tbl-btn"
                  onClick={(e) => this.voiceCall(item, e)}
                >
                  <i className="ms-Icon ms-Icon--Phone" aria-hidden="true"></i>
                </button>)}

              </div>
            )
          );
        };
      } else if (
        ["firstName", "lastName", "birthDate", "changedProcessAt", "assignedToCloserAt", "phone", "city", "zipCode"].includes(col.key)
      ) {
        const oldRender = col.onRender;
        col.onRender = (item) => {
          if (item.key === "filterRow") {
            return this.renderHeaderFilter(col);
          }
          return oldRender ? oldRender(item) : item[col.fieldName];
        };
      }

      return col;
    });
  }

  resetPageData(customers) {
    this.setState({
      customers: customers && customers.length > 0 ? customers : [],
      showCustomerDialog: false,
      newCustomer: {
        processResults: "LE",
        zipCode: (this.state.zipCodes[0] || {}).key,
        birthDate: new Date()
      },
      insurancedoc: null
    });
  }

  renderHeaderFilter({ fieldName, name = "" }) {

    let timeout;

    if (fieldName == "changedProcessAt") {
      return (
        <StartEndDateFilter startDateField={"createdStart"} endDateField={"createdEnd"}
          fetch={this.fetch} searchBox={this.props.searchBox}
          headerFilters={this.state.headerFilters}
          updateStateCallback={this.updateStateCallback}
        />
      );

    }

    if (fieldName === "assignedToCloserAt") {
      
      return (
        <StartEndDateFilter
          startDateField={"closerAssignStart"}
          endDateField={"closerAssignEnd"}
          fetch={this.fetch}
          searchBox={this.props.searchBox}
          headerFilters={this.state.headerFilters}
          updateStateCallback={this.updateStateCallback}
        />
      );

    }

    return (
      <TextField
        name={fieldName}
        placeholder={`Find ${name.toLowerCase()}`}
        value={this.state.headerFilters[fieldName]}
        onChanged={(value) => {

          if (timeout) {
            clearTimeout(timeout);
          }
          this.setState(
            {
              headerFilters: {
                ...this.state.headerFilters,
                [fieldName]: value,
              },
            },
            () => {
              timeout = setTimeout(() => {
                this.fetch(this.props.searchBox, 0);
              }, 300);
            }
          );
        }}
      />
    );
  }



  render() {
    const {
      isLoading,
      hasMore,
      customers,
      newCustomer,
      filterStaff,
      total,
      staffs,
      closers,
      openHeaderFilters,
      showCatDialog
    } = this.state;

    const isCloserPage =
      _.get(this.props, "location.state.isCloser") ||
      _.get(this.props, "auth.user.accountType") === USER_TYPE.CLOSER;

    var user = this.props.auth.user;
    const isVendor = user.orgType == 'vendor';

    const columns = this.handleGetColumnConfig(isCloserPage, isVendor);

    let filenames = "";

    if (this.state.insurancedoc) {

      filenames = this.state.insurancedoc.length + " files chosen...";

    }

    // render HTML
    return (
      <div style={{ margin: 10 }}>
        {!isVendor && (<div style={{
          position: "fixed",
          top: 40,
          left: 0,
          right: 0,
          zIndex: 999,
          background: "white",
          padding: "10px 15px 15px 15px",
        }}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              justifyContent: "space-between",
            }}
          >
            {["admin", "manager", "staff", "closer"].includes(
              this.props.auth.user.accountType
            ) && (
                <PrimaryButton onClick={() => this.showDialog()}>
                  Add customer
                </PrimaryButton>
              )}
            {/* <div style={{ width: 300 }} className="one-line-200">
              <Dropdown
                label="Filter by Patient Assignment"
                selectedKey={filter}
                options={[{ key: "all", text: "All" }].concat(
                  patientAssignment
                )}
                onChanged={(v) => this.changeFilter(v)}
              />
            </div> */}
            {this.props.auth.user.accountType == "admin" && !isCloserPage && (
              <div style={{ width: 300 }} className="one-line-100">
                <Dropdown
                  label="Filter by Staff"
                  selectedKey={filterStaff}
                  options={[{ key: "all", text: "All" }].concat(staffs)}
                  onChanged={(v) => this.changeFilterStaff(v)}
                />
              </div>
            )}
            {this.props.auth.user.accountType == "admin" && isCloserPage && (
              <div style={{ width: 300 }} className="one-line-100">
                <Dropdown
                  label="Filter by Closer"
                  selectedKey={filterStaff}
                  options={[{ key: "all", text: "All" }].concat(closers)}
                  onChanged={(v) => this.changeFilterStaff(v)}
                />
              </div>
            )}
            <div
              style={{
                display: "flex",
                marginBottom: 10,
                marginLeft: 50,
                alignItems: "center",
              }}
            >
              <div style={{ marginRight: 20 }}>Filter by ZipCodes</div>
              <TagPicker
                ref="zipCodes"
                onResolveSuggestions={this._onFilterChanged.bind(this)}
                onChange={(items) => this.changeFilterByZipCodes(items)}
                getTextFromItem={(item) => {
                  return item.name;
                }}
                onRenderSuggestionsItem={(item) => (
                  <span
                    style={{
                      color: item.needReAssign ? "blue" : "",
                      fontWeight: item.needReAssign ? "600" : "",
                    }}
                  >
                    {item.name}
                  </span>
                )}
                pickerSuggestionsProps={{
                  suggestionsHeaderText: "Zip Codes",
                  noResultsFoundText: "No Zip Code Found",
                }}
                defaultSelectedItems={this.filterZipCodes}
              />
            </div>
            {["admin", "manager", "central-user"].includes(
              _.get(this.props, "auth.user.accountType")
            ) && (
                <div
                  className="ms-Grid-col ms-u-md6"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div
                    style={{
                      margin: "0px 10px 10px 0px",
                      width: 140,
                      float: "left",
                    }}
                  >
                    <Label>Filter by Lead Class</Label>

                  </div>
                  <div style={{ width: "150px" }}>
                    <Dropdown
                      options={this.state.leadClasses}
                      selectedKey={this.state.leadClass}
                      onChanged={(v) =>
                        this.changeFilter("leadClass", v.key)
                      }
                    />
                  </div>
                </div>
              )}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "flex-end",
              }}
            >
              <div
                style={{ width: 180, marginLeft: 50 }}
                className="one-line-100"
              >
                <Dropdown
                  label="Year of Birth"
                  selectedKey={this.state.filterYearStart}
                  options={[{ key: 0, text: "--" }].concat(
                    this.state.dateRangeOptions
                  )}
                  onChanged={(v) =>
                    this.changeFilterYear(
                      v.key < this.state.filterYearEnd ||
                        v.key === 0 ||
                        this.state.filterYearEnd == 0
                        ? v.key
                        : this.state.filterYearStart,
                      this.state.filterYearEnd
                    )
                  }
                />
              </div>
              <div
                style={{ width: 130, marginLeft: 20 }}
                className="one-line-50"
              >
                <Dropdown
                  label="to"
                  style={{ width: 100 }}
                  selectedKey={this.state.filterYearEnd}
                  options={[{ key: 0, text: "--" }].concat(
                    this.state.dateRangeOptions
                  )}
                  onChanged={(v) =>
                    this.changeFilterYear(
                      this.state.filterYearStart,
                      v.key > this.state.filterYearStart ||
                        v.key == 0 ||
                        this.state.filterYearStart == 0
                        ? v.key
                        : this.state.filterYearEnd
                    )
                  }
                />
              </div>
            </div>
            {_.get(this.props, "location.state.isCloser") && (
              <div className="one-line-50" style={{ marginLeft: 40 }}>
                <Checkbox
                  checked={this.state.filterReminder}
                  onChange={(e) =>
                    this.changeFilter("filterReminder", e.target.checked)
                  }
                  label="Future reminder only"
                />
              </div>
            )}

            {this.state.userData && this.state.userData.phonecall && (
              <div style={{ display: "flex" }}>
                <div style={{ width: 300 }}>
                  <TextField
                    ref="phoneNumber"
                    className="one-line-100"
                    label="Call A Number"
                    placeholder="enter phone number"
                  ></TextField>
                </div>
                <div>
                  <PrimaryButton
                    onClick={() => this.callButtonClick()}
                    style={{ width: 150, height: 34 }}
                  >
                    {this.state.callingToCustomer || this.state.callingToPhone ? "HANG UP" : "CALL"}
                  </PrimaryButton>
                  <span style={{ fontSize: 20, marginLeft: 20, color: "red" }}>
                    {this.state.callStatus}
                  </span>
                  {this.state.callingToCustomer && (
                    <span
                      style={{ fontSize: 20, marginLeft: 10, color: "red" }}
                    >
                      {">"} {this.state.callingToCustomer.phone} |{" "}
                      {this.state.callingToCustomer.firstName}{" "}
                      {this.state.callingToCustomer.lastName}
                    </span>
                  )}
                  {this.state.callingToPhone && (
                    <span
                      style={{ fontSize: 20, marginLeft: 10, color: "red" }}
                    >
                      {">"} {this.state.callingToPhone}
                    </span>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>)}
        <div style={{ marginTop: 50 }}>
          <InfiniteScroll
            pageStart={0}
            loadMore={() => this.fetch()}
            useWindow={true}
            initialLoad={false}
            style={{ marginBottom: 30, position: "relative", top: isVendor ? 0 : 100 }}
            loader={
              isLoading ? (
                <Spinner key={1} size={SpinnerSize.large} />
              ) : (
                <span key={2}></span>
              )
            }
            hasMore={hasMore}
          >
            <DetailsList
              setKey={"_id"}
              items={[
                ...(openHeaderFilters ? [{ key: "filterRow" }] : []),
                ...customers,
              ]}
              columns={columns}
              selectionPreservedOnEmptyClick={true}
              selectionMode={SelectionMode.none}
              onColumnHeaderClick={() =>
                this.setState({
                  openHeaderFilters: !this.state.openHeaderFilters,
                })
              }
              onRenderRow={(props) => {


                let bgcolor = "";

                if (props.item.key !== "filterRow") {

                  let diffDays = 0;
                  if (props.item.assignedToCloserId && props.item.assignedToCloserAt) {
                    //let diffTime = moment(new Date()).format("MMM DD YYYY") - moment(props.item.assignedToCloserAt).format("MMM DD YYYY");
                   
                    diffDays = moment(new Date()).diff(moment(props.item.assignedToCloserAt), 'days');
                  }

      
                  if (diffDays >= 7)
                    bgcolor = "rgb(255,204,0)";
                  else if (!props.item.medicareNumber)
                    bgcolor = "rgb(255,192,203)";
                  else if (props.item.lastServedVendorId)
                    bgcolor = "rgb(194,229,211)";

                }

                return (
                  <div
                    ref={(e) => (this.rowRefs[props.item._id] = e)}
                    style={{
                      borderBottom: "1px solid #e6e6e6",
                      background:
                        props.item.key === "filterRow"
                          ? "rgba(240, 240, 240, 1)"
                          : "",
                    }}

                  >
                    <div
                      ref={(e) => (this.div[props.item._id] = e)}
                      onClick={() =>
                        props.item.key !== "filterRow" &&
                        this.selectItem(props.item)
                      }
                      className="row-hover" style={{ backgroundColor: bgcolor }}
                    >
                      <DetailsRow {...props} />

                      {isCloserPage && props.item.key !== "filterRow" && this.rowSelected && props.item._id === this.rowSelected._id && showCatDialog && (
                        <AssignCategoryForm rowSelected={this.rowSelected}
                          selected={this.selected}
                          assignCategoryCallback={this.updateStateCallback}
                          showDialog={showCatDialog}
                          refreshCustomerList={this.refreshCustomerList}
                          sequentialLeadNumber={this.state.sequentialLeadNumber}
                          isCloserPage={isCloserPage}
                        />)

                      }

                      {props.item.key !== "filterRow" && (
                        <div
                          style={{ padding: "0 0 10px 8px" }}
                          className="ms-fontColor-themePrimary"
                        >
                          {props.item.patientAssignment && (
                            <div style={{ marginBottom: 10, fontWeight: "bold" }}>
                              {_.get(
                                PATIENT_ASSIGNMENT_LIST.find(
                                  (opt) =>
                                    opt.key === props.item.patientAssignment
                                ),
                                "text",
                                ""
                              )}
                            </div>
                          )}
                          {props.item.leadCategory && (
                            <div style={{ marginBottom: 10 }}>
                              <span style={{ fontWeight: "bold" }}>
                                {_.get(
                                  LEAD_CATEGORY_LIST.find(
                                    (opt) => opt.key === props.item.leadCategory
                                  ),
                                  "text",
                                  ""
                                )}
                              </span>
                              {props.item.closerRemind && (
                                <span>
                                  {" - Remind at "}
                                  <span
                                    style={{ color: "red", fontWeight: "bold" }}
                                  >
                                    {moment(props.item.closerRemind).format(
                                      "MMM DD YYYY"
                                    )}
                                  </span>
                                </span>
                              )}
                            </div>
                          )}
                          {this.props.auth.user.accountType !==
                            USER_TYPE.CLOSER &&
                            props.item.assignedToCloser && (
                              <div
                                style={{ marginBottom: 10, fontWeight: "bold" }}
                              >
                                {`Closer: ${props.item.assignedToCloser.fname} ${props.item.assignedToCloser.lname} | ${props.item.assignedToCloser.email}`}
                              </div>
                            )}

                        {isVendor && 
                            props.item.assignedToVendor &&(
                          <div style={{ fontWeight: "600" }}>
                            {`Vendor: ${props.item.assignedToVendor.fname} ${props.item.assignedToVendor.lname} | ${props.item.assignedToVendor.email}`}
                          </div>
                        )}
                            
                          <div>
                            <i>{props.item.comments || "--No comments--"}</i>
                          </div>
                        </div>
                      )}
                    </div>
                    {props.item.key !== "filterRow" && (
                      <LeadForm
                        ref={(e) => (this.forms[props.item._id] = e)}
                        data={props.item}
                        insurancedoc={props.item.insurancedoc}
                        onCancel={() => this.hiddenForm(props.item)}
                        onSave={(data) => this.save(data)}
                        token={this.props.auth.user.token}
                      />
                    )}
                  </div>
                );
              }}
            />
          </InfiniteScroll>
        </div>
        <StatusBar>
          <span>Total: {total}</span>
          {this.selectedItem && (
            <span>
              {" "}
              | Selected: #{customers.indexOf(this.selectedItem) + 1} -{" "}
              {`${this.selectedItem.firstName} ${this.selectedItem.lastName}`}{" "}
            </span>
          )}
        </StatusBar>

        {this.state.showCustomerDialog && (
          <CustomerAddEditForm
            showDialog={this.state.showCustomerDialog}
            isEditing={this.state.isEditing}
            closers={this.state.closers}
            closeDialog={this.closeDialog}
            theCustomer={newCustomer}
            refreshCustomerList={this.refreshCustomerList}
            isCloserPage={isCloserPage}
          />
        )

        }
      </div>
    );
  }
}

export default connect((state) => ({
  auth: state.auth,
  searchBox: state.app.searchBox || { filter: "", text: "" },
}))(Lead);



// WEBPACK FOOTER //
// ./client/components/Lead.js